import { CustomizerDataType } from "../../../Types/ThemeCustomizerTypes";

export const navLinkList: CustomizerDataType[] = [
    {
        path: 'https://support.pixelstrap.com/agent/pixelstrap/pixelstrap/tickets/list/open-cases',
        icon: 'icon-briefcase',
        name: 'Support'
    },
    {
        path: 'https://docs.pixelstrap.com/Cion/all_in_one/document/index.html',
        icon: 'icon-wallet',
        name: 'Document'
    },
    {
        path: 'https://admin.pixelstrap.com/cion/template/landing-page.html#frameworks',
        icon: 'icon-receipt',
        name: 'Check Features'
    },
    {
        path: 'https://1.envato.market/3GVzd',
        icon: 'icon-shopping-cart-full',
        name: 'Buy Now'
    }
]